import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';
var buildGetReadTokenURL = function buildGetReadTokenURL(accountId) {
  return "/api/user-image/".concat(accountId, "/header-image/read");
};
export var UserPreferencesClient = /*#__PURE__*/function (_RestClient) {
  _inherits(UserPreferencesClient, _RestClient);
  var _super = _createSuper(UserPreferencesClient);
  function UserPreferencesClient() {
    _classCallCheck(this, UserPreferencesClient);
    return _super.apply(this, arguments);
  }
  _createClass(UserPreferencesClient, [{
    key: "getReadMediaToken",
    value: function () {
      var _getReadMediaToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(accountId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.getResource(buildGetReadTokenURL(accountId)).then(function (response) {
                return response;
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getReadMediaToken(_x) {
        return _getReadMediaToken.apply(this, arguments);
      }
      return getReadMediaToken;
    }()
  }, {
    key: "getWriteMediaToken",
    value: function () {
      var _getWriteMediaToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.getResource('/api/user-image/header-image/write').then(function (response) {
                return response;
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getWriteMediaToken() {
        return _getWriteMediaToken.apply(this, arguments);
      }
      return getWriteMediaToken;
    }()
  }, {
    key: "updateUserHeaderImage",
    value: function () {
      var _updateUserHeaderImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(headerImageId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.putResource('/api/user-image/self/header-image', {
                headerImageId: headerImageId
              });
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateUserHeaderImage(_x2) {
        return _updateUserHeaderImage.apply(this, arguments);
      }
      return updateUserHeaderImage;
    }()
  }]);
  return UserPreferencesClient;
}(RestClient);
export default new UserPreferencesClient({
  serviceUrl: DEFAULT_CONFIG.stargateRoot
});